import qs from 'query-string';
import { BASE_URL } from '../config';
import customFetch from './../../function/customFetch';
import axios from './../../function/axiosInstance';
import extract from './../../function/extract';
import { MIME_TYPE } from '../../constant/enum/mimeType';
import { getDocsContent, postDocsContent } from '../../api/editor/editor';
const url = `${BASE_URL}/assignments`;
export const createThread = async ({ id, type, text, attachments }) => {
    try {
        const response = await axios.post(`/assignments/${id}/threads`, {
            type,
            text,
            attachments
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const fetchThreads = async ({ id, type }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        const queryParamsThreadApi = type ? `type=${type}` : '';
        const response = await customFetch(`${url}/${id}/threads?${queryParamsThreadApi}`, { headers });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.threads,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: [],
            error: error.message
        };
    }
};
export const fetchMentions = async ({ id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/mention-suggestions`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const createMessage = async ({ id, text, attachments }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${BASE_URL}/threads/${id}/messages`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ text, attachments })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const fetchList = async ({ query_params = {}, isPaginatedList = true, page = 0, page_size = 100 }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const reqQueryParams = new URLSearchParams();
    if (isPaginatedList) {
        reqQueryParams.append('current_page', page.toString());
        reqQueryParams.append('page_size', page_size.toString());
    }
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    try {
        const response = await customFetch(`${url}?${reqQueryParams.toString()}`, {
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: {
                    records: result.records,
                    total_records: result.total_records
                },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: {
                records: [],
                total_records: 0
            },
            error: error.message
        };
    }
};
export const fetchDetails = async ({ id, companyId }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    try {
        const endpoint = qs.stringifyUrl({ url: `${url}/${id}`, query: { company_id: companyId } }, { skipNull: true, skipEmptyString: true });
        const response = await customFetch(endpoint, { headers });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: undefined,
            error: error.message
        };
    }
};
export const editDetails = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const editDeadline = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/deadline`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const updateBulkAssignmentStatus = async (body) => {
    try {
        const response = await axios.put('/assignments/status', body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const resolveAssignmentStatus = async (body) => {
    try {
        const response = await axios.post('/assignments/resolve', body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const unScrapAssignmentStatus = async (body) => {
    try {
        const response = await axios.post('/assignments/unscrapped', body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getWordsLength = (str) => {
    str = str.replace(/(^\s*)|(\s*$)/gi, '');
    str = str.replace(/[ ]{2,}/gi, ' ');
    str = str.replace(/\n /, '\n');
    if (str === '')
        return 0;
    return str.split(' ').length;
};
const _getLocalContent = async (assignmentId) => {
    var _a, _b, _c, _d, _e, _f;
    const localAssignmentString = localStorage.getItem(`assignment_data_${assignmentId}`);
    if (!localAssignmentString) {
        return null;
    }
    const response = await getDocsContent({
        id: assignmentId
    });
    const localAssignment = JSON.parse(localAssignmentString);
    const isLocalContentNewer = ((_b = (_a = localAssignment === null || localAssignment === void 0 ? void 0 : localAssignment.body) === null || _a === void 0 ? void 0 : _a.extras) === null || _b === void 0 ? void 0 : _b.createdAt) > ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.extras) === null || _d === void 0 ? void 0 : _d.createdAt);
    localStorage.removeItem(`assignment_data_${assignmentId}`);
    if (!((_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.extras) === null || _f === void 0 ? void 0 : _f.createdAt) || isLocalContentNewer) {
        return localAssignment === null || localAssignment === void 0 ? void 0 : localAssignment.body;
    }
    return null;
};
export const updateAssignmentContent = async (assignmentId) => {
    const updatedLocalData = await _getLocalContent(assignmentId);
    if (!updatedLocalData)
        return {
            status: 'ok',
            data: null,
            error: undefined
        };
    const response = await postDocsContent({
        id: assignmentId,
        body: updatedLocalData
    });
    if (response.data && !response.error) {
        return {
            status: 'ok',
            data: response.data,
            error: undefined
        };
    }
    else {
        return {
            status: 'error',
            data: null,
            error: 'Unable to sync editor content.'
        };
    }
};
export const updateAssignmentStatus = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/status`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: { result, id },
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const getContentAuditStatus = async ({ assignmentId, stateId }) => {
    try {
        let auditUrl = `/assignments/${assignmentId}/content-audit`;
        if (stateId) {
            auditUrl += `?state_id=${stateId}`;
        }
        const response = await axios.get(auditUrl);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const postContentAuditStatus = async (assignmentId, params) => {
    try {
        const response = await axios.post(`${url}/${assignmentId}/content-audit`, {
            ...(params !== null && params !== void 0 ? params : {})
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const uploadOpenSubmissionFiles = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/submission-documents`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const redactAssignment = async ({ id }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/redact`, {
            method: 'PUT',
            headers
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: response,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const updateDeadline = async ({ id, deadline }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/deadline`, {
            method: 'PUT',
            headers,
            body: JSON.stringify({ deadline })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: response,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const fetchWorkflow = async (id) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/workflow`, { headers });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const submitBulkFeedback = async (feedback) => {
    try {
        const response = await axios.post(`${url}/feedback`, {
            assignments_feedback: feedback
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const createFeedback = async ({ assignment_id = '', rating = 1, feedback_text = '', inputs = [], compliments = [] }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${assignment_id}/feedback`, {
            method: 'POST',
            headers,
            body: JSON.stringify({ rating, feedback_text, inputs, compliments })
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const handleAcceptAssignment = async ({ showMessage, assignment_id, body }) => {
    try {
        const response = await updateAssignmentStatus({
            id: assignment_id,
            body
        });
        if (response.status === 'ok') {
            const message = 'Assignment(s) successfully accepted.';
            showMessage && showMessage({ type: 'success', message });
            return { isSuccess: true, message };
        }
        else {
            throw new Error(response.error);
        }
    }
    catch (error) {
        const message = error.message || 'Unknown error occurred. Try again after some time.';
        showMessage && showMessage({ type: 'error', message });
        return { isSuccess: false, message };
    }
};
export const editAssigneeDetails = async ({ id, body }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const response = await customFetch(`${url}/${id}/assignee-details`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(body)
        });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const fetchFeedbacks = async (id, query) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    };
    try {
        const endpoint = qs.stringifyUrl({ url: `${url}/${id}/feedback`, query }, { skipNull: true, skipEmptyString: true });
        const response = await fetch(endpoint, { headers });
        const result = await response.json();
        if (response.ok) {
            return {
                status: 'ok',
                data: result.data,
                error: undefined
            };
        }
        throw new Error(result.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const downloadSubmissionFile = async ({ id, format = 'pdf' }) => {
    const headers = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
    };
    const fileType = MIME_TYPE[format].type;
    try {
        const response = await customFetch(`${url}/${id}/doc?action=download&format=${fileType}`, {
            headers
        });
        const result = await response.blob();
        const blob = new Blob([result], {
            type: fileType
        });
        const file = new File([blob], `Assignment.${format}`, {
            type: fileType
        });
        if (response.ok) {
            return {
                status: 'ok',
                data: file,
                error: undefined
            };
        }
        const jsonResult = await response.json();
        throw new Error(jsonResult.description);
    }
    catch (error) {
        return {
            status: 'error',
            data: null,
            error: error.message
        };
    }
};
export const getAssignmentSubmissionFileURL = async (assignmentId) => {
    try {
        const response = await axios.get(`/assignments/${assignmentId}/doc-url`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const makeThreadSeen = async ({ assignmentId }) => {
    try {
        const response = await axios.put(`/assignments/${assignmentId}/threads/message-receipts`, { read: 1 });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const addBulkAssignmentPay = async ({ body }) => {
    try {
        const response = await axios.put(`/assignments/amount`, body);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const fetchAuditDetails = async ({ assignmentId, auditId }) => {
    try {
        const response = await axios.get(`/assignments/${assignmentId}/content-audit?audit_id=${auditId}`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const updateBulkAssignments = async (payload) => {
    try {
        const response = await axios.put(`/assignments`, payload);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const ignoreAuditDetails = async ({ assignmentId, auditId, category, type, errors }) => {
    try {
        const response = await axios.put(`/assignments/${assignmentId}/content-audit/${auditId}`, {
            category,
            type,
            errors
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const activeOpportunitiesAssignmentDetails = ({ user_Id, query_params = {}, page = 0, page_size = 5 }) => {
    const reqQueryParams = new URLSearchParams();
    reqQueryParams.append('current_page', page.toString());
    reqQueryParams.append('page_size', page_size.toString());
    Object.keys(query_params).forEach(key => {
        const queryParam = query_params[key];
        if (queryParam && queryParam.toString()) {
            reqQueryParams.set(key, queryParam.toString());
        }
    });
    return axios
        .get(`/assignments?active-allotment=true&user_id=${user_Id}&stage=request&${reqQueryParams.toString()}&sort_by=assignment_status_code&sort_order=desc&favourite_creator=true`)
        .then((data) => {
        return data;
    })
        .catch(error => error);
};
export const missedOpportunitiesAssignmentDetails = (key, user_Id) => {
    return axios
        .get(`/assignments?missed-allotment=true&user_id=${user_Id}&page_size=10&current_page=0`)
        .then((data) => {
        return data.data;
    })
        .catch(error => error);
};
export const getNewOpportunitiesCount = async () => {
    try {
        const response = await axios.get(`/opportunities/new-count`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const showInterestInAssignment = async (dispatch_id) => {
    try {
        const response = await axios.put(`/opportunities/${dispatch_id}`, {
            data: {
                showed_interest: true
            }
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const relevanceForAssignment = async ({ dispatch_id, flag }) => {
    try {
        const response = await axios.put(`/opportunities/${dispatch_id}`, {
            data: {
                missed: {
                    is_relevant: flag
                }
            }
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getFeedbackTypes = () => {
    return axios
        .get(`/opportunities/dispatch-feedback-types`)
        .then((data) => data.data.data)
        .catch(error => error);
};
export const passOpportunity = async ({ dispatch_id, id }) => {
    try {
        const response = await axios.post(`/opportunities/pass/${dispatch_id}`, {
            feedback: id
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const claimOpportunity = async ({ dispatch_id, deadline, assignee_pay, assignment_id, high_pay }) => {
    try {
        const response = await axios.post(`/opportunities/claim/${dispatch_id}`, {
            deadline: deadline,
            assignee_pay: assignee_pay,
            assignment_id: assignment_id,
            high_pay: high_pay
        });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getFlaggedCreatorDetails = async (assignmentId) => {
    try {
        const response = await axios.get(`/assignments/${assignmentId}/creator-flags`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const updateAssignmentInvoicingStatus = async ({ assignmentIds, invoicingStatus }) => {
    try {
        const response = await axios.put(`/assignments/invoice-status/${invoicingStatus}`, { assignment_ids: assignmentIds });
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
export const getAssignmentMargin = async (assignmentId) => {
    try {
        const response = await axios.get(`/assignments/${assignmentId}/allotment-margin`);
        return extract.data(response);
    }
    catch (error) {
        return extract.error(error);
    }
};
//# sourceMappingURL=assignments.js.map